import { render, staticRenderFns } from "./indexMain.vue?vue&type=template&id=75a55a2a&scoped=true"
import script from "./indexMain.vue?vue&type=script&lang=js"
export * from "./indexMain.vue?vue&type=script&lang=js"
import style0 from "./indexMain.vue?vue&type=style&index=0&id=75a55a2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a55a2a",
  null
  
)

export default component.exports